'use strict';

import analytics from '../../analytics';
import dialog from '../../dialog';
import minicart from '../../minicart';
import page from '../../page';
import util from '../../util';
import _ from 'lodash-es';
import gymsharkRecommendation from './recommendations';
const cartPage = $('.cart_page').length > 0 ? true : false ;

/**
 * @description set addToCart error message
 * @param {String} msg
 */
var timer;
var setAddToCartError = function (msg) {
	var $errEle = $("#a2c-error"),
        $qtyEle = $(".pdp-main .product-info .add-to-bag-wrapper"),
        isMobile = util.isMobile();
	
    $errEle.html(msg).show();
    if ($('.paypalpaylater').length) {
        $('.paypalpaylater').addClass('margin-added');
    }
    
    if (isMobile && $qtyEle.length) {
        var bottomValue = $('.paypalpaylater').length ? $qtyEle.outerHeight(true) + 40 + "px" : $qtyEle.outerHeight(true) + "px";
        $errEle.css({bottom: bottomValue});
    
        if (timer) {
            clearTimeout(timer);
        }
    
        timer = setTimeout(function () {
            $errEle.hide();
        }, 3000);
    }
      
};

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
    var $form = $(form),
	$qty = $form.find('select[name="Quantity"]');
    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val('1');
    }
    
    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            localStorage.removeItem('productLimit');
            setAddToCartError(response.error);
            throw new Error(response.error);
            return false;
        }

        return response;
    });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    addItemToCart($form).then(function (response) {
        var $uuid = $form.find('input[name="uuid"]');
       
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            page.refresh();
        } else {
            // do not close quickview if adding individual item that is part of product set
            // @TODO should notify the user some other way that the add action has completed successfully
            if (!$(this).hasClass('sub-product-item')) {
                dialog.close();
            }
            
            $(document).trigger("gtadd-to-cart");
            if ($(this).closest('li').hasClass('recommendation-item') && ($('#cart-items-form').length > 0 || $(this).parents().hasClass('cart-empty-container'))) {
                $('.minicart-overlay').hide();
                page.refresh();
            } else {
                if($(this).closest('.plp-cross-sell').length) {
                    analytics.addToBagPLPCrosssell($(this).closest('.recommendation-item'), e);
                }
                minicart.show(response);
                gymsharkRecommendation.crosssellRecommendationModal();
                analytics.cartModalOpen();
                localStorage.setItem("cartModalOpen", "miniCartOpen");
            }
            if($('.mini-cart-product').length > 1) {
                $('.scrollbar-inner').trigger("resize.scrollBox");
            }
            //cart page recommendation page refresh
            if ($(this).closest('li').hasClass('recommendation-item') && ($('#cart-items-form').length > 0 || $(this).parents().hasClass('cart-empty-container') )) {
                $('.minicart-overlay').hide();
                page.refresh();
            }
       }
    }.bind(this));

};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllTo = function (e) {
    e.preventDefault();

    var pidData = formatPidDataFromEles($('.product-set-list').find('form'));
    const errorElement = $(this).find('#a2c-error');
    minicart.addAllProducts(pidData, e.data.to, errorElement);
};

/**
 * @description Handler to add all products from a Shoppable Media "Shop The Look" carousel to the cart
 */
const shopTheLook = (e) => {
    e.preventDefault();

    const $container = $(e.currentTarget).closest('.shop-look-row, .shoppable-media-section');

    const pids = [
        ...new Set(
            $container
                .find('li.grid-tile[data-pid]')
                .map((_, el) => $(el).data('pid') || el.getAttribute('data-pid'))
                .get()
                .filter(Boolean)
                .map(pid => String(pid).trim())
        )
    ].map(pid => `${pid}:1`);

    if (!pids.length) return;

    minicart.addAllProducts(
        pids.join(','),
        'Cart',
        $container.find('#a2c-error, .a2c-error')
    );
};

// Accepts jQuery selector of n elements containing data attr storing pid
// Returns formatted pid data required for addAllProducts request (ex. 'pidA:1,pidB:1,pidN:1')
// To fetch qty, searches for qty dropdown or defaults to 1
function formatPidDataFromEles($selector) {
    return $selector.toArray().map(function (ele) {
        var $qtyfield = $('.product-form-actions');
        var qtyVal = $qtyfield.find('select[name="Quantity"]');
        var $ele = $(ele),
            pid = $ele.data('pid'),
            qty = $ele.find('select[name="Quantity"]').length ? $ele.find('select[name="Quantity"]').val() : ( qtyVal != '' && qtyVal != undefined) ? qtyVal.val() : "1";

        return pid + ":" + qty;
    }).join(',');
}

/**
 * duplicated add-to-cart from export above - endorse for re-factoring
 * reason for duplication : sometimes add to bag/cart script won't trigger/execute
 */
$(document).on('click', '.product-detail .add-to-cart', addToCart);
$(document).on('click', 'button#samples-add-to-cart', addSamplesToCart);
$(document).on('click', 'button#oos_email_btn', oosEmail);
$(document).on('click', '.shop-look-row .shop-look-cta', shopTheLook);
$(document).on('click', 'button#oos_email_btn_registered', oosEmail);
$(document).on('click', 'button.multiselect', multiSelectButton);
$(document).on('click', '.sample-popup-tile', function () {
    var isSampleRedesign = ($(this).closest('.sample-selection-redesign').length>0);
    if(!isSampleRedesign) {
        $(this).siblings('button.multiselect').trigger('click');
    }
});
$(document).on('click', '.reveal.sample-selection .close-button', function (e) {
    scrollToTop(e);
});
$("form.multi-select-form").on('submit', function (e) {
    e.preventDefault();
    const errorElement = $(this).find('#a2c-error');

    var pidData = formatPidDataFromEles($(this).find('button.multiselect[value="selected"]'));
    minicart.addAllProducts(pidData, 'Cart', errorElement);
});
$(window).on('load', function() {
    if (typeof YMK !== 'undefined') {        
       window.YMK.addEventListener('addToBag', function(result) {
        var $addToBagErrorElement = $(this).closest(".compare-shades-actions.global-add-to-bag").find(".global-add-to-cart-error");
        minicart.addProduct({ pid: result, Quantity: '1', MMProduct: true }, $addToBagErrorElement);
       });
    }
});

function multiSelectButton(e){
    var isBonusSampleRedesign = ($(this).closest('.bonus-item-modal-redesign').length > 0) || ($(this).closest('.sample-selection-redesign').length>0);

    if(!isBonusSampleRedesign) {
        e.preventDefault();

        var $this = $(this);
        var $multiSelectForm = $this.parents('form');
        var $thresholdInput = $multiSelectForm.find('input#pids');

        var selectedCount = $multiSelectForm.find('button[value="selected"]').length;
        var limitCount = $(this).closest('.sample-selection').length ? SitePreferences.SAMPLES_PER_ORDER_COUNT : window.Constants.MAX_BONUS_ITEMS;
            
        if ($('#sampleserror')) {
            $('#sampleserror').html(null);
        }

        // do checking to compare if limit is met
        var btnIsSelected = $this.val() == 'selected';

        if (btnIsSelected || selectedCount < limitCount) {
            // toggle val/text
            $this.toggleClass('outline');
            $this.val(btnIsSelected ? 'selectable' : 'selected');
            $this.html(btnIsSelected ? $this.data('select') : $this.data('selected'));
        } else if ($('#sampleserror')) { // cap reached, report error
            $('#sampleserror').html($("input#pids").data('error'));

            $('.modal-body').animate({
                scrollTop:  0
            }, 200);
        }

        var selectedProductList = [];
        var enableAddToBag = false;

        // fetch all items that are selected
        $multiSelectForm.find('button[value="selected"]').each(function(index, item) {
            selectedProductList.push($(item).data('pid'));
            enableAddToBag = true;
        });

        // store all selected products to hidden input
        $thresholdInput.val(selectedProductList);

        // update selected counter
        var selectedCount = parseInt(selectedProductList.length);
        var selectedLimit = parseInt(limitCount);
        $("span#sample-count").html((selectedCount <= selectedLimit ? selectedCount : selectedLimit));

        // enable "Add to Bag" button
        var cartButton = $thresholdInput.data('button');
        if (enableAddToBag) {
            $('button#' + cartButton).removeAttr('disabled');
        } else {
            $('button#' + cartButton).attr('disabled', 'true');
        }
    }


}

function addSamplesToCart(e) {
    if(!cartPage) {
        e.preventDefault();
        analytics.addSelectedSamplesToCart();
        var url = util.toAbsoluteUrl($(this).data('action'));

        $.ajax({
            url: util.appendParamToURL(url, 'format', 'ajax'),
            data: { pid: $(this).parents('form').find("input#pids").val() },
            method: 'POST'
        }).done(function (response) {
            if($('#samples-add-to-cart').data('redirect')) {
                if ($(".pt_cart").length) {
                    window.location.assign(Urls.cartShow);
                } else {
                    page.refresh();
                }
            } else {
                minicart.show(response);
            }
        });
    }
}

function oosEmail(e) {
	var regexEmail = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const $comingSoonWrapper = $('.coming-soon-container');
    const $oosEmailBtn = $('.oos_email_btn');
    const productId = $(this).parents('form').find("input#dwfrm_emailbackinstockregistration_productId").val();
    e.preventDefault();
    if ($('.oos_email_form_registered').length) {
        var url = util.toAbsoluteUrl($("#dwfrm_emailbackinstockregistration").attr('action'));	
        $.ajax({
            url: util.appendParamToURL(url, 'format', 'ajax'),
            data: { 
                    pid : productId,
                    isCommingSoon : $(".oos_email_form input.commingsoon").length > 0 ? $(".oos_email_form input.commingsoon").val() : null 
            },
            method: 'POST'
         }).done(function (response) {
            $(".oos_notify").hide();
            $(".oos_email_form span.error").remove();
            if ($comingSoonWrapper.length) {
                $comingSoonWrapper.addClass('success');
                analytics.notifyMeClick(productId);
            }
            $(".oos_email_sent").show();
            $oosEmailBtn.text($oosEmailBtn.data('sent-text'));
        });
    } else {
        if( !($(".oos_email_form input.email").val().length === 0) && regexEmail.test($(".oos_email_form input.email").val()) ){
            
            var url = util.toAbsoluteUrl($("#dwfrm_emailbackinstockregistration").attr('action'));	
        
            $.ajax({
                url: util.appendParamToURL(url, 'format', 'ajax'),
                data: { 
                        email: $(this).parents('form').find("input#dwfrm_emailbackinstockregistration_email").val(), 
                        pid : $(this).parents('form').find("input#dwfrm_emailbackinstockregistration_productId").val(),
                        isCommingSoon : $(".oos_email_form input.commingsoon").length > 0 ? $(".oos_email_form input.commingsoon").val() : null 
                },
                method: 'POST'
             }).done(function (response) {
                $(".oos_email_sent").show();
                $(".oos_notify").hide();
                $(".oos_email_form span.error").remove();
                if ($comingSoonWrapper.length) {
                    $comingSoonWrapper.addClass('success');
                    analytics.notifyMeClick(productId);
                }
                $oosEmailBtn.text($oosEmailBtn.data('sent-text'));
            });
        }
        
        else{
            if(!($(".oos_email_form span.error").text())){
                $(".oos_email_form .form-row .field-wrapper").append(
                        ' <span id="dwfrm_emailbackinstockregistration_email-error" class="error">'+Resources.VALIDATE_EMAIL+'</span> '
                );
            }
            return false;
        }
    }
	
}

function initStickyAddToBag() {
    if (util.isMobile()) {
        const windowTop = $(window).scrollTop();
        let container;
        if($('#sticky-anchor').length) {
            container = $('#sticky-anchor').offset().top + 60;
        }
        let stickyBottomContainer;

        if($('.coming-soon-container').length) {
            stickyBottomContainer = $('.coming-soon-container');
        } else if($('.oos-container').length) {
            stickyBottomContainer = $('.oos-container');
        } else {
            stickyBottomContainer = $('.add-to-bag-wrapper');
        }

        if (windowTop > container) {
            $(stickyBottomContainer).addClass('sticky-add-to-bag');
            let stickyHeightPaypal = 0;
            const stickyHeightContainer = $(stickyBottomContainer).height();
            if($(".paypalpaylater").length) {
                $(".paypalpaylater").addClass('sticky-add-to-bag');
                stickyHeightPaypal = $(".paypalpaylater.sticky-add-to-bag").height();
            } else {
                $(stickyBottomContainer).css("bottom", "0");
            }
            const stickyScrollTopHeight = stickyHeightPaypal + stickyHeightContainer + 35;
            $(".scroll-top-wrapper").css("bottom", stickyScrollTopHeight + "px");
        } else {
            $(stickyBottomContainer).removeClass('sticky-add-to-bag');
            if($(".paypalpaylater").length) {
                $(".paypalpaylater").removeClass('sticky-add-to-bag');
            }
            $(".scroll-top-wrapper").css("bottom", "2em");
        }
    }
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
export default function () {
    $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
    $('#add-all-to-cart').on('click', {to: 'Cart'}, addAllTo);
    $('.product-form-actions .product-set-wishlist').on('click', {to: 'Wishlist'}, addAllTo);
    $(document).on('scroll', initStickyAddToBag);
    initStickyAddToBag();
};